import React, { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const gallery = [
  { src: 'https://images.unsplash.com/photo-1519699047748-de8e457a634e?q=80&auto=format&fit=crop&w=1200', alt: 'Portrait — glowing skin' },
  { src: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?q=80&auto=format&fit=crop&w=1200', alt: 'Makeup atelier tools' },
  { src: 'https://images.unsplash.com/photo-1580618672591-eb180b1a973f?q=80&auto=format&fit=crop&w=1200', alt: 'Salon craft in motion' },
  { src: 'https://images.unsplash.com/photo-1512496015851-a90fb38ba796?q=80&auto=format&fit=crop&w=1200', alt: 'Editorial beauty portrait' },
  { src: 'https://images.unsplash.com/photo-1600334129128-685c5582fd35?q=80&auto=format&fit=crop&w=1200', alt: 'Skin ritual detail' },
  { src: 'https://images.unsplash.com/photo-1595476108010-b4d1f102b1b1?q=80&auto=format&fit=crop&w=1200', alt: 'Finished bridal look' },
]

export default function SignatureArtistry() {
  const ref = useRef<HTMLElement>(null)

  useEffect(() => {
    if (!ref.current) return

    const ctx = gsap.context(() => {
      const imgs = ref.current?.querySelectorAll('.art__img')
      if (!imgs) return

      imgs.forEach((img, i) => {
        gsap.fromTo(
          img,
          { opacity: 0, scale: 0.9, filter: 'blur(8px)' },
          {
            opacity: 1,
            scale: 1,
            filter: 'blur(0px)',
            duration: 1,
            ease: 'power3.out',
            scrollTrigger: {
              trigger: img,
              start: 'top 85%',
              once: true,
            },
            delay: (i % 3) * 0.1,
          }
        )
      })
    }, ref.current)

    return () => ctx.revert()
  }, [])

  return (
    <section ref={ref} className="art">
      <div className="art__header">
        <span className="art__label">Signature Artistry</span>
        <h2 className="art__title">Get Inspired</h2>
      </div>
      <div className="art__grid">
        {gallery.map((g, i) => (
          <div key={i} className="art__img-wrap">
            <img
              src={g.src}
              alt={g.alt}
              className="art__img"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </section>
  )
}